// 機能訓練レポート・月選択画面.
import * as React from 'react';
import * as Header from '../constants/Header';
import UserDetail, { DummyUserDetail } from './common/UserDetail';
import { JS_VOID } from '../utils/commonUtil';
import { MDate, getYearMonthArray, getFirstEndDay } from '../utils/dateUtil';
import * as Enumerable from 'linq';
import '../css/press.css';
import '../css/month_select.css';
import LiterallyReportPDF from './LiterallyReportPDF';
import { Institution } from '../constants/MoffCheck';
import * as _ from 'lodash';
import * as moment from 'moment';

interface LiterallyReportSelectMonthProps extends React.Props<{}> {
  moffAPI: any;
  moffAPIActions: any;
  literallyReportActions: any;

  // BI
  barthelIndex: any;
  barthelIndexActions: any;
  // HDS-R
  hdsr: any;
  hdsrActions: any;

  headerActions?: any;

  // 前ページのユーザーID.
  match?: any;

  literallyReport: any;
}

interface LiterallyReportSelectMonthState {
  date: MDate;
  // 長期変化.
  locomoState: number;
}

/**
 * 月選択画面のクラス.
 *
 * @export
 * @class LiterallyReportSelectMonth
 * @extends {React.Component<LiterallyReportSelectMonthProps, LiterallyReportSelectMonthState>}
 */
export default class LiterallyReportSelectMonth extends React.Component<
  LiterallyReportSelectMonthProps, LiterallyReportSelectMonthState> {
  private cachedUser: any;
  private userId: string;

  private yearSelected: string;
  // 0埋め2桁.
  private monthSelected: string;
  private mDate: MDate;

  // 子コンポーネントの参照.
  private child: LiterallyReportPDF;

  componentWillMount() {
    document.title = '機能訓練レポート';  

    this.props.headerActions.setPage(Header.LITERALLY_REPORT_SELECT_MONTH);

    this.mDate = new MDate();
    this.refresh();

    // URLのパラメータ.
    this.userId = this.props.match.params.userId;
    this.runAPI();
  }

  /**
   * 描画.
   *
   * @returns
   * @memberof LiterallyReportSelectMonth
   */
  render() {
    return (
      <div>
        <style type="text/css">
          {'a:link, a:visited, a:active {color:#000;text-decoration:none;}'}
        </style>
        {
          (() => {
            if (this.props.moffAPI.Loaded) {
              // キャッシュさせておく.
              if (this.props.moffAPI.result.user) {
                this.cachedUser = this.props.moffAPI.result.user;
              }

              return;
            }

            // 最初の年月ボタンのローディング中
            return <div><div id="loader" /><div id="loader_back" /></div>;
          })()
        }
        { // PDFを開く.
          (() => {
            if (this.props.barthelIndex.Loading || this.props.hdsr.Loading) {
              // PDFを開くためのローディング中
              return <div><div id="loader" /><div id="loader_back" /></div>;
            } else if (this.props.barthelIndex.Loaded && this.props.hdsr.Loaded) {
              this.runGeneratePDF(this.props.barthelIndex.result, this.props.hdsr.result);
              return (null);
            }
            return (null);
          })()
        }

        <article className="report">
          {(this.props.moffAPI.Loaded || this.cachedUser) ? 
            // ロードしたUserを表示
            // ロードした利用者の詳細
            <UserDetail user={this.props.moffAPI.result.user || this.cachedUser} /> 
            :
            <DummyUserDetail />
          }
          <section id="sec02">
            <h2 className="ttlStyle01">機能訓練レポートを表示する月を選んで下さい</h2>
            <div className="inner">
              <div className="calendarHeader">
                <div className="dateArea">
                  <div className="date">
                    {this.yearSelected}<span className="year">年</span>{this.monthSelected}<span>月までの1年分を表示</span>
                  </div>
                  <div className="btn left">
                    <a href={JS_VOID} onClick={this.minusMonthly} />
                  </div>
                  <div className="btn right">
                    <a href={JS_VOID} onClick={this.plusMonthly} />
                  </div>
                </div>
              </div>
              { // データ数でのif
                (() => {
                  if (this.props.moffAPI.Loading) {
                    return <div><p>読み込み中</p></div>;
                  } else if (this.props.moffAPI.Loaded) {
                    return this.renderDispYearMonth();
                  } else {
                    return (null);
                  }
                })()
              }
            </div>
            {/* PDFを開くための準備 */}
            {(this.props.moffAPI.Loaded || this.cachedUser) ? 
              <LiterallyReportPDF
                ref={(instance: LiterallyReportPDF) => { this.child = instance; }}
                user={this.props.moffAPI.result.user || this.cachedUser}
              />  : (null)
            }
          </section>
        </article>
      </div>
    );
  }

  /**
   * リフレッシュ.
   *
   * @memberof LiterallyReportSelectMonth
   */
  private refresh = () => {
    this.yearSelected = this.mDate.year;
    this.monthSelected = this.mDate.month;
    this.setState({date: this.mDate});
  }

  /**
   * ボタンたちを描画.
   *
   * @returns {JSX.Element}
   * @memberof LiterallyReportSelectMonth
   */
  private renderDispYearMonth(): JSX.Element {
    // key: 2017-08, value: count.
    let dispYearMonth: object = this.props.moffAPI.result.dispYearMonth;

    // 12+1=13ヶ月分とっているので、一番古い月(12ヶ月前)の1つ前の月を削除して数える.
    const removeKey = moment(`${this.mDate.year}-${this.mDate.month}-01`).add(-12, 'months').format('YYYY-MM');
    dispYearMonth = _.omit(dispYearMonth, removeKey);
    const cnt: number = Object.keys(dispYearMonth).length;

    if (cnt === 0) {
      return (<p>データがありません。</p>);
    }

    return (
      <div className="button_image">
      {
        // すでに数が0のは選定済み.
        Enumerable.from(dispYearMonth)
        .select<JSX.Element>((element: { key: string; value: any; }, index: number) => {
          const yearMonth = element.key;
          return<span key={`pressSelectButton${index}`}>
            <a
              // PDFを生成.
              onClick={
                () => {
                  this.runAPIForGetBIRecords(yearMonth);
                }
              }
              className={index % 2 === 0 ? 'month_grey' : 'month_white'}
              target="_blank"
            >
              <span key={`pressSelectYearMonth${index}`}>{yearMonth}</span>
            </a>
          </span>;
        }).toArray()
      }
      </div>
    );
  }

  /**
   * BI取得のAPIを実行.
   *
   * @private
   * @param {string} yearMonth
   * @memberof LiterallyReportSelectMonth
   */
  private runAPIForGetBIRecords = (yearMonth: string): void => {
    if (this.props.moffAPI.Loading || this.props.barthelIndex.Loading || this.props.hdsr.Loading) {
      return;
    }

    const [yearSelected, monthSelected] = yearMonth.split('-');

    // 選んだ日の半年(6ヶ月)前の1日と、選んだ日の最終日.
    const [startDate, endDate] = getFirstEndDay(yearSelected, monthSelected, 6);

    // 月末かつ最後の時間 23:59:59.999.
    let unixTime: number = moment(`${yearSelected}-${monthSelected}`).endOf('month').endOf('day').unix();
    unixTime = Number(`${unixTime}999`);

    // BIを取得するAPIを実行.
    this.props.barthelIndexActions.getBIRecords(this.userId, startDate, endDate, yearMonth, unixTime);

    // HDS-R(MCI)を取得するAPIを実行.
    this.props.hdsrActions.getHDSRData(this.userId, yearMonth, unixTime);
  }

  /**
   * エラーでもこちらに来る.
   * biDataは{}になる、yearMonthを使う.
   * 通信終えてからPDFを開く.
   *
   * @private
   * @param {*} biParam
   * @param {*} hdsrParam
   * @returns {void}
   * @memberof LiterallyReportSelectMonth
   */
  private runGeneratePDF(biParam: any, hdsrParam: any): void {
    // リセット.
    this.props.barthelIndexActions.initialize();
    this.props.hdsrActions.initialize();

    if (_.isEmpty(biParam) || _.isEmpty(hdsrParam)) {
      return;
    }

    // 施設名の取得.
    const institution: Institution = this.props.moffAPI.result.institutions.institution;
    const facilityName = institution.institution_name;

    // HDS-Rの点数(ないときと実際に0点は別扱い).
    let hdsrPoint = -1;
    if (hdsrParam.hdsr) {
      if (hdsrParam.hdsr.answers) {
        hdsrPoint = Enumerable.from(hdsrParam.hdsr.answers).sum();
      }
    }

    this.child.runGeneratePDF(
      facilityName, hdsrPoint,
      hdsrParam.yearMonth, this.props.moffAPI.result.resultTrainingObj, biParam.bi);
  }

  /**
   *  範囲内でAPIを叩く.
   *
   * @memberof LiterallyReportSelectMonth
   */
  private runAPI() {
    // 12ヶ月 + 1ヶ月（最初の月の1つ前）分.
    const yearMonthArr: string[] = getYearMonthArray(this.yearSelected, this.monthSelected, 12 + 1);
    // 範囲内でAPIを叩く.
    // Action
    this.props.literallyReportActions.getMoffCheckData(this.userId, yearMonthArr);
  }

  /**
   * 右をクリックしたときの処理.
   *
   * @memberof LiterallyReportSelectMonth
   */
  private plusMonthly = () => {
    if (this.props.moffAPI.Loading || this.props.barthelIndex.Loading || this.props.hdsr.Loading) {
      return;
    }

    // 次の月.
    this.mDate.setNextMonth();
    this.refresh();
    this.runAPI();
  }

  /**
   *  左をクリックしたときの処理.
   *
   * @memberof LiterallyReportSelectMonth
   */
  private minusMonthly = () => {
    if (this.props.moffAPI.Loading || this.props.barthelIndex.Loading || this.props.hdsr.Loading) {
      return;
    }

    // 先月.
    this.mDate.setPreMonth();
    this.refresh();
    this.runAPI();
  }
}



// WEBPACK FOOTER //
// ./src/components/LiterallyReportSelectMonth.tsx